import { Fragment } from 'react';
import Heading from '@/components/atoms/Heading';
import Image from 'next/image';
import { useTheme } from 'styled-components';
import { Separator } from '@/components/atoms/Separator';

import chippu_logo from '@/assets/logo_chippu.svg';
import simply_logo from '@/assets/simply-logo-white.png';

import Text from '@/components/atoms/Text';

import * as S from './styles';
import useFooterCorpoHook from '../../hook/useFooterCorpoHook';
import Accordion from '@/components/atoms/Accordion';
import AccordionItem from '@/components/molecules/AccordionItem';
import Link from '@/components/atoms/Link';
import { registrarEvento } from '@/services/googleAnalytics';

export default function FooterCorpoMobile() {
  const theme = useTheme();

  const {
    linksChippu,
    linksServicos,
    webView,
    RedesSociais,
    LojasAplicativos,
    FaleConosco,
  } = useFooterCorpoHook();

  return (
    <Fragment>
      <S.ColunaInformacoes>
        <Accordion $size={1} $style="ghost">
          <AccordionItem
            $size={4}
            $variant="ghost"
            $disabled="off"
            $title="Chippu"
            $conteudo={
              <S.ColunaLinks>
                {linksChippu.map((link, index) => (
                  <Link
                    key={index}
                    href={link.href}
                    $size={2}
                    $color="neutral"
                    $weight="light"
                    $underline={false}
                    $highContrast={true}
                    $text={link.texto}
                    $onClick={() => {
                      registrarEvento(link.eventoAnalytics, {});
                    }}
                  />
                ))}
              </S.ColunaLinks>
            }
            $styleConteudo={{
              backgroundColor: '#1d5754',
              padding: `0 ${theme.spacing[3]}px`,
              borderRadius: theme.radius[2],
            }}
          />
        </Accordion>
        <Accordion $size={1} $style="ghost">
          <AccordionItem
            $size={4}
            $variant="ghost"
            $disabled="off"
            $title="Serviços"
            $conteudo={
              <S.ColunaLinks>
                {linksServicos.map((link, index) => (
                  <Link
                    key={index}
                    href={link.href}
                    $size={2}
                    $color="neutral"
                    $weight="light"
                    $underline={false}
                    $highContrast={true}
                    $text={link.texto}
                    $onClick={() => {
                      registrarEvento(link.eventoAnalytics, {});
                      if (link.href.includes('termos'))
                        sessionStorage.removeItem('termoHTML');
                    }}
                  />
                ))}
              </S.ColunaLinks>
            }
            $styleConteudo={{
              backgroundColor: '#1d5754',
              padding: `0 ${theme.spacing[3]}px`,
              borderRadius: theme.radius[2],
            }}
          />
        </Accordion>
        <Accordion $size={1} $style="ghost">
          <AccordionItem
            $size={4}
            $variant="ghost"
            $disabled="off"
            $title="Fale com a gente"
            $styleConteudo={{
              backgroundColor: '#1d5754',
              borderRadius: theme.radius[2],
            }}
            $conteudo={
              <div style={{ padding: `0 ${theme.spacing[3]}px` }}>
                <FaleConosco />
              </div>
            }
          />
        </Accordion>
      </S.ColunaInformacoes>
      {!webView ? (
        <Fragment>
          <Separator $block={false} $orientation="horizontal" />
          <S.ColunaAplicativos>
            <Heading
              $priority={5}
              $size={4}
              $color="neutral"
              $weight="medium"
              $align="left"
              $highContrast={true}
              $text="Baixe o app"
            />
            <LojasAplicativos />
          </S.ColunaAplicativos>
        </Fragment>
      ) : null}
      <Separator $block={false} $orientation="horizontal" />
      <S.ColunaLogos>
        <RedesSociais />
        <S.LinhaImagens>
          <Image
            src={chippu_logo}
            alt="Chippu Logo"
            height={theme.typography.font.size[8]}
            priority
          />
          <Image
            src={simply_logo}
            alt="Simply Slogan"
            height={theme.typography.font.size[9]}
            priority
          />
        </S.LinhaImagens>
        <Text
          $size={1}
          $color="neutral"
          $weight="regular"
          $align="left"
          $highContrast={false}
          $text="© 2025 – Chippu by Omelete Company"
        />
      </S.ColunaLogos>
    </Fragment>
  );
}
